import React from "react";
import { Flex } from "./shared/Flex";
import styled from "styled-components";

const LoadingWrapper = styled(Flex)`
  position: fixed;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  flex-direction: column; /* Stack spinner and text vertically */
  width: 100vw;
  height: 100vh;
  background: #d3d3d3; /* Solid light grey background */
  z-index: 10;
`;

const Spinner = styled.div`
  border: 6px solid #f3f3f3; /* Light grey border */
  border-top: 6px solid #01061b; /* Dark blue border for the spinning part */
  border-radius: 50%;
  width: 80px; /* Increased size of the spinner */
  height: 80px; /* Increased size of the spinner */
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Message = styled.h2`
  font-size: 25px;
  color: #01061b;
  font-weight: normal;
  margin-top: 20px; /* Adds space between the spinner and the text */
`;

const Loader = () => (
  <LoadingWrapper>
    <Spinner />
    <Message>{"Loading..."}</Message>
  </LoadingWrapper>
);

export default Loader;
